<p-toast></p-toast>
<div class="w-full px-4">
  <div class="w-full flex flex-column gap-3">
    <div class="flex align-items-center justify-content-between">
      <h1 class="text-left font-bold text-4xl m-0">Contact Us Requests</h1>
      <p-button icon="pi pi-download" (click)="downloadContactUsList()" label="Download Contact Us Summary" [loading]="isExportLoading" styleClass="sampleBtn" />
    </div>
    <div class="w-full flex flex-column gap-2 py-4 px-3 bg-white border-round-2xl shadow-2">
      <h2 class="text-left text-xl font-medium">Contact Us Submissions</h2>
      <div class="flex flex-wrap align-items-end gap-2 mb-3">
        <div class="flex flex-column gap-1">
          <label for="filterName" class="text-sm font-medium">Name</label>
          <p-autoComplete
            id="filterName"
            [(ngModel)]="filterName"
            [suggestions]="nameSuggestions"
            (completeMethod)="searchNames($event)"
            (onSelect)="onNameSelect($event)"
            (keydown.enter)="applyFilters()"
            placeholder="Name"
            styleClass="w-full"
            [style]="{'width':'100%'}"
            appendTo="body">
          </p-autoComplete>
        </div>
        <div class="flex flex-column gap-1">
          <label for="filterPhone" class="text-sm font-medium">Phone Number</label>
          <p-autoComplete
            id="filterPhone"
            [(ngModel)]="filterPhone"
            [suggestions]="phoneSuggestions"
            (completeMethod)="searchPhones($event)"
            (onSelect)="onPhoneSelect()"
            (keydown.enter)="applyFilters()"
            placeholder="Phone Number"
            styleClass="w-full"
            [style]="{'width':'100%'}"
            appendTo="body">
          </p-autoComplete>
        </div>
        <div class="flex flex-column gap-1">
          <label for="filterEmail" class="text-sm font-medium">Email</label>
          <p-autoComplete
            id="filterEmail"
            [(ngModel)]="filterEmail"
            [suggestions]="emailSuggestions"
            (completeMethod)="searchEmails($event)"
            (onSelect)="onEmailSelect()"
            (keydown.enter)="applyFilters()"
            placeholder="Email"
            styleClass="w-full"
            [style]="{'width':'100%'}"
            appendTo="body">
          </p-autoComplete>
        </div>
        <p-button label="Search" icon="pi pi-search" (onClick)="applyFilters()" />
        <p-button label="Clear" icon="pi pi-times" severity="secondary" (onClick)="clearFilters()" />
      </div>
      <p-table
        *ngIf="requests && requests.length > 0; else noRecordsFound"
        [value]="requests"
        [lazyLoadOnInit]="false"
        [paginator]="requests.length !== total"
        [rows]="rowSize"
        [loading]="isSearching"
        [totalRecords]="total"
        [first]="first"
        [lazy]="true"
        (onLazyLoad)="onLazyLoad($event)"
        [rowsPerPageOptions]="[10, 20, 30]"
        [showPageLinks]="true"
        styleClass="p-datatable-gridlines tableCon"
        [tableStyle]="{ 'min-width': '50rem' }">
        <ng-template pTemplate="header">
          <tr>
            <th>Date</th>
            <th>Name</th>
            <th>Email</th>
            <th>Phone</th>
            <th>Purpose</th>
            <th>Message</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr>
            <td>{{ row.createdOn | date:'short' }}</td>
            <td>{{ row.firstName }} {{ row.lastName }}</td>
            <td>{{ row.email }}</td>
            <td>{{ row.phoneNumber || '-' }}</td>
            <td>{{ getPurposeLabel(row.contactPurpose) }}</td>
            <td>{{ row.message || '-' }}</td>
          </tr>
        </ng-template>
      </p-table>
      <ng-template #noRecordsFound>
        <div class="w-full flex flex-column align-items-center py-4 gap-5">
          <div class="w-full flex align-items-center justify-content-center">
            <img src="../../../assets/icons/nodatafound.svg" alt="" class="w-full max-w-16rem">
          </div>
          <b class="text-center font-normal text-2xl" style="color: #000086;">No Data Found!</b>
        </div>
      </ng-template>
    </div>
  </div>
</div>
